// extracted by mini-css-extract-plugin
module.exports = {"footer":"WorkpapersFooter__footer___Yt9Id","next":"WorkpapersFooter__next___S1pJN"};